import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/Footer.css';
import LinkedlnIcon from '../website_images/Icons/linkedIn.png';
import XingIcon from '../website_images/Icons/xing.png';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
                <p>&copy; {t('footerText')}</p>
          </div>    
          <div className="footer-section">
            <div className="social-links">
              <Link to="/impressum" className="social-link">
                <span className="social-icon"></span>
                <span>{t('imprint')}</span>
              </Link>
              <Link to="/datenschutz" className="social-link">
                <span className="social-icon"></span>
                <span>{t('dataSecurity')}</span>
              </Link>
            </div>
          </div>  
          {/**     
          <div className="footer-section">
            <div className="social-links">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link linkedin">
                <img src={LinkedlnIcon} alt="LinkedIn" className="social-icon"/>
              </a>
              <a href="https://xing.com" target="_blank" rel="noopener noreferrer" className="social-link xing">
                <img src={XingIcon} alt="Xing" className="social-icon"/>
              </a>
            </div>
          </div>*/}
        </div>
        
        
      </div>
    </footer>
  );
};

export default Footer;